(function () {
  'use strict';

  /* @ngdoc object
   * @name messageAdmin
   * @description
   *
   */
  angular
    .module('flightCargo', [
      'ui.router'
    ]);
}());
